import { styled } from '@linaria/react';

import { Accordion } from '~/shared/ui/Accordion/Accordion';
import { Typography } from '~/shared/ui/Typography/Typography';

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Main = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: calc(100vh - 56px);
  position: relative;
`;

export const Rate = styled(Typography.H5)`
  display: flex;
  align-self: center;
`;

export const Content = styled.div<{ isExpanded: boolean }>`
  padding: 16px;
  padding-bottom: ${({ isExpanded }) => (isExpanded ? '86px' : '16px')};
  overflow-y: auto;
`;

export const BottomContent = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10;
  margin: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  background: rgba(0, 0, 0, 0.8);
  box-shadow:
    0 -20px 30px rgba(0, 0, 0, 0.9),
    0 -10px 20px rgba(0, 0, 0, 0.6),
    0 -5px 10px rgba(0, 0, 0, 0.5),
    0 20px 30px rgba(0, 0, 0, 0.9),
    0 10px 20px rgba(0, 0, 0, 0.6),
    0 5px 10px rgba(0, 0, 0, 0.5);
`;

export const ButtonLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
`;

export const StyledAccordion = styled(Accordion)`
  margin-top: 16px;
`;
